import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import { message } from "antd";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { deleteRole, getPermission } from "../../../utils/ApiCalls/Permission";
import { checkPermission } from "../../../utils/Validation/checkPermission";

const Roles = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Roles",
      route: "/profile/roles",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [{ permission }, dispatch] = useDataLayerValue();
  const columns = [
    {
      title: "Sl",
      width: 30,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (text, record, index) => (page - 1) * 10 + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 50,
      render: (text, record, index) => <div>{text}</div>,
    },
    {
      title: "Action",
      key: "operation",
      width: 100,
      render: (text, record) => (
        <div className="table_action_btn">
          <button className="btn" onClick={() => handleEdit(record.id)}>
            <i className="ri-edit-2-line" data-toggle="tooltip" title="Edit"></i>
          </button>
          <DeletePop onConfirm={() => handleDelete(record.id)}>
            <div>
              {" "}
              <button className="btn delete_btn">
                <i
                  className="ri-delete-bin-line"
                  data-toggle="tooltip"
                  title="Delete"
                ></i>
              </button>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];
  useEffect(() => {
    getData(page);
  }, [page, pageSize]);

  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Role",window?.location?.pathname)) {
      await deleteRole(id);
      await getData();
    } else {
      message.error("Missing Permission for delete");
    }
  };

  const getData = async (value) => {
    let data = await getPermission({ page: value, limit: pageSize });
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };
  const handleEdit = async (id) => {
    navigate("/profile/role/edit/" + id);
  };

  return (
    <Layout type={"read_per"} module_data={"Roles"}>
      <CustomHeaderTitle title={"Roles"} />
      <div>
        <div>
          <HeaderBread navigation={navigation} title={"Roles"}></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header two_item">
                <h5 className="card-title">Roles List</h5>
                <div className="two_item">
                  <Link to="/profile/role/add" className="btn add_v_btn">
                    Add Role
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <div className="table_holder">
                  <CustomizedTable
                    setRows={setRows}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    pageSize={pageSize}
                    page={page}
                    count={count}
                    columns={columns}
                    rows={rows}
                    title={"NewsLetter"}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Roles;
